'use client'

import type { Course } from '@/payload-types'

import { useLivePreview } from '@payloadcms/live-preview-react'

import { CoursePageContent } from './CoursePageContent'
import { getServerSideURL } from '@/utilities/getURL'

type Props = {
  initialCourse: Course
}

export const CoursePreview = ({ initialCourse }: Props) => {
  const { data } = useLivePreview<Course>({
    depth: 2,
    initialData: initialCourse,
    serverURL: getServerSideURL(),
  })

  if (!data) return null

  return <CoursePageContent course={data} />
}
